import React, { useRef, useState, useEffect } from "react";
import { Button, TextField, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";

import EmployeeList from "@components/Modal/Payroll/EmployeeList";
import { fetchPayrolls } from "@redux/actions";
import { salaryCalculate } from "@utils/utils";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  form: {
    padding: theme.spacing(2),
  },
  textField: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
}));

const GenerateMonthBankSlip = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const componentRef = useRef();

  const [isSubmit, setIsSubmit] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(
    new Date().toISOString().slice(0, 7)
  );
  const [chequeValue, setChequeValue] = useState("");
  const [payroll, setPayroll] = useState([]);
  const [employeeModalOpen, setEmployeeModalOpen] = useState(false);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleChange = (e) => {
    setChequeValue(e.target.value);
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const createProcessedPayloadPayroll = (payload) => {
    return payload
      .filter(
        (data) =>
          data.employee_id.bank_name &&
          data.employee_id.bank_name.slice(0, 6).toLowerCase() === "meezan"
      )
      .map((data) => ({
        ...data,
        employee: data.employee_id,
        tax: Math.abs(data.tax),
        final_salary: salaryCalculate(data),
      }));
  };

  const handleEmployeeModalOpen = () => {
    setEmployeeModalOpen(true);
  };

  const handleEmployeeModalClose = () => {
    setEmployeeModalOpen(false);
    setChequeValue("");
  };

  const handleSubmit = async (event) => {
    console.log("Selected Month:", selectedMonth);
    event.preventDefault();

    if (!chequeValue) {
      alert("Please enter cheque number");
      return;
    }

    setIsSubmit(true);

    try {
      const res = await dispatch(fetchPayrolls(selectedMonth));
      const payrolls = res?.data?.payload;

      if (payrolls?.length > 0) {
        const processedPayroll = createProcessedPayloadPayroll(payrolls);
        setPayroll(processedPayroll);
      }

      handleEmployeeModalOpen();
    } catch (error) {
      console.error("Failed to fetch payrolls:", error);
    } finally {
      setIsSubmit(false);
    }
  };
  const getEmployees = (employees) => {
    setSelectedEmployees(employees);
  };

  useEffect(() => {
    if (selectedEmployees.length > 0) {
      handlePrint();
    }
  }, [selectedEmployees]);

  return (
    <form autoComplete="off" className={classes.form} onSubmit={handleSubmit}>
      <p className={classes.textField}>
        Generate Bank letter for Meezan Bank holders
      </p>

      <TextField
        id="salary_date"
        label="Choose Month"
        required
        type="month"
        value={selectedMonth}
        onChange={handleMonthChange}
        className={classes.textField}
        InputLabelProps={{ shrink: true }}
        inputProps={{
          max: moment().format("YYYY-MM"),
        }}
      />

      <TextField
        id="cheque_number"
        label="Enter Cheque Number"
        required
        type="text"
        value={chequeValue}
        onChange={handleChange}
        className={classes.textField}
        InputLabelProps={{ shrink: true }}
      />

      <Grid container direction="column" alignItems="flex-end">
        <Grid item>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isSubmit}
          >
            Generate Bank Slip
          </Button>
        </Grid>
      </Grid>

      <EmployeeList
        ref={componentRef}
        employees={payroll}
        chequeNumber={chequeValue}
        selectedMonth={selectedMonth}
        onClose={handleEmployeeModalClose}
        onSelectEmployees={getEmployees}
        onOpen={employeeModalOpen}
      />
    </form>
  );
};

export default GenerateMonthBankSlip;
